
import React, {FC, useCallback, useEffect} from 'react';
import {useFormikContext} from 'formik';
import {debounce} from 'lodash';

interface AutoSaveProps {
	debounce?: number
}

export const AutoSave: FC<AutoSaveProps> = ({debounce: millis = 250}) => {
	const formik = useFormikContext();

	// Wrap submitForm in debounce call
	const submit = useCallback(
		debounce(
			() => {
				return formik.submitForm();
			},
			millis,
		),
		[formik.submitForm, millis],
	);

	// Call submit function if values change
	useEffect(
		() => {
			submit();
		},
		[submit, formik.values],
	);

	return <></>;
};

